import React, { useState, useEffect } from 'react';
import Form from '../../np-form/Form';
import { Dialog, withStyles } from '@material-ui/core';
import * as formUtility from '../../np-form/utility';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        margin: theme.spacing(2),
    }
});

const updateFirstFormState = props => {
    const { classes, customers, vehicle } = props;

    // First form
    const firstForm = {
        Name: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'Name',
                label: 'Name',
                className: classes && classes.inputs ? classes.inputs : null,
                margin: "dense",
                fullWidth: true
            },
            value: vehicle ? vehicle.Name : null,
            validation: {
                required: true
            },
            valid: true,
            touched: false
        },
        LicenseNumber: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'License number',
                label: 'License number',
                className: classes && classes.inputs ? classes.inputs : null,
                margin: "dense",
                fullWidth: true
            },
            value: vehicle ? vehicle.LicenseNumber : null,
            validation: {
                required: true
            },
            valid: true,
            touched: false
        },
        Payload: {
            elementType: 'input',
            elementConfig: {
                type: 'number',
                placeholder: 'Payload',
                label: 'Payload',
                className: classes && classes.inputs ? classes.inputs : null,
                margin: "dense",
                fullWidth: true
            },
            value: vehicle ? vehicle.Payload : null,
            validation: {
                required: true,
                isNumeric: true
            },
            valid: true,
            touched: false
        },
        CustomerID: {
            elementType: 'select',
            elementConfig: {
                type: 'select',
                label: 'Customer',
                className: null,
                margin: "dense",
                fullWidth: true,
                options: customers ? [...customers] : []
            },
            formHelperText: "Please select customer",
            value: vehicle ? vehicle.CustomerID : null,
            validation: {
                required: true
            },
            valid: true,
            touched: false
        }
    };
    return firstForm;
}

const VehicleEdit = props => {
    const { open, classes, activeCustomer } = props;

    const [vehicleForm, setVehicleForm] = useState(updateFirstFormState({ ...props }));
    const [vehicleFormValid, setVehicleFormValid] = useState(false);

    useEffect(() => {
        setVehicleForm(updateFirstFormState({ ...props }));
    }, [props]);

    const inputChangedHandler = (event, inputIdentifier) => {
        const updateState = formUtility.getNewStateOnInputChange(event, inputIdentifier, vehicleForm);
        setVehicleForm(updateState.myForm);
        setVehicleFormValid(updateState.formIsValid);
    };

    const submitHandler = event => {
        event.preventDefault();
        const formVehicle = formUtility.getFormData(vehicleForm);
        formVehicle['VehicleID'] = props.vehicle ? props.vehicle.VehicleID : null;
        props.editVehicle({ ...formVehicle, ActiveCustomerID: activeCustomer });
        props.handleEdit();
        setVehicleForm(updateFirstFormState({}));
        setVehicleFormValid(false);
    };

    const cancelHandler = () => {
        setVehicleForm(updateFirstFormState({}));
        setVehicleFormValid(false);
        props.handleEdit();
    };

    return (
        <Dialog
            open={open}
            disableBackdropClick={true}
            disableEscapeKeyDown={false}
            disableEnforceFocus={true}
            fullWidth={true}
            onClose={cancelHandler}
        >
            <Form
                formIsValid={vehicleFormValid}
                classes={classes}
                form={vehicleForm}
                inputChangedHandler={inputChangedHandler}
                formTitle='Edit Vehicle'
                submitButtonStyle={{ borderRadius: '1px' }}
                buttonText='Submit'
                buttonTextCancel='Cancel'
                submitHandler={submitHandler}
                cancelHandler={cancelHandler}
            />
        </Dialog>
    )
}
export default withStyles(styles, { withTheme: true })(VehicleEdit);